var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from './BaseApi';
const noop = () => { };
export class IdwRwcApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getIdwRwcData() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-rwc'),
            method: 'GET',
        });
    }
    upsertIdwRwcData(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-rwc'),
            method: 'POST',
            data,
        });
    }
    deleteIdwRwcData() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-rwc'),
            method: 'DELETE',
        });
    }
    installRwcChat() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-rwc/install'),
            method: 'POST',
        });
    }
    getChatStatus() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-rwc/install'),
            method: 'GET',
        });
    }
    getSubscriptionOnInstallationProcess(pollingInterval, tikCallback = noop, errorCallback = noop) {
        const $this = this;
        let intervalId;
        return {
            subscribe: function () {
                intervalId = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const status = yield $this.getChatStatus();
                        tikCallback(status);
                    }
                    catch (e) {
                        errorCallback(e);
                        this.unsubscribe();
                    }
                }), pollingInterval);
            },
            unsubscribe: function () {
                clearInterval(intervalId);
            },
        };
    }
}
//# sourceMappingURL=idwRwcApi.js.map